<template>
  <BaseUiStyle />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
